import { create } from "zustand";
import questionMappingService from "../services/questionMappingService";
import testResultService from "../services/testResultService";

const useDoTestStore = create((set) => ({
  answers: [],
  questions: [],
  test_id: null,
  isDirty: false,
  count_done: 0,
  error: null,
  result: null,
  isLoading: false,


  fetchQuestions: async (test_id) => {
    console.log('Test');
    set({test_id: test_id})
    try {
      const questions = await questionMappingService.getMappingByTestId(test_id)
      const answerTemplate = questions.data.map(question => ({
        question_id: question.question_id,
        answer: ""
      }))
      set({questions: questions.data,answers: answerTemplate,isDirty: false,
        count_done: 0,
        error: null,
        result: null,
        isLoading: false,  })

    } catch (error) {
      console.error(error)
    }
  },
  // newAnswer: { answer: string, question_id: string }
  addAnswerTest: (newAnswer) => {
    const { answers} = useDoTestStore.getState()
    console.log('Test:', answers)

    const oldAnswer = answers.find(item => item.question_id === newAnswer.question_id)
    console.log(newAnswer,answers)
    console.log(oldAnswer)

    let count_done = answers.filter(answer => answer.answer!=="").length
    if (oldAnswer.answer==="") count_done++
    oldAnswer.answer = newAnswer.answer

    set({answers: answers, isDirty: true, count_done: count_done})
  },

  checkDone: () => {
    const { answers} = useDoTestStore.getState()
    const isDone = !answers.find(answer => answer.answer === "")
    return isDone
  },

  submit: async () => {
    try {
      set({isLoading: true})
      const { test_id,count_done, answers} = useDoTestStore.getState()
    if (count_done===answers.length) {
      // handle submit
      const response = await testResultService.scoreTest({
        answers,
        test_id
      })
      set({result:response.data })
      setTimeout(() => {
        set({isLoading: false})
      }, 2000);
    }
    else {
      alert("Vui lòng hoàn thành toàn bộ trước khi nộp bài!")
      set({error: "Vui lòng hoàn thành toàn bộ trước khi nộp bài!"})
    }
    } catch (error) {
      console.error(error)
    }
    finally {
      set({isLoading: false})
    }

  },

  submitWriting: async () => {
    try {
      set({isLoading: true})
      const { test_id,count_done, answers} = useDoTestStore.getState()
      if (count_done===answers.length) {
        // handle submit
        const response = await testResultService.scoreTestWriting({
          answer: answers[0].answer,
          test_id,
          question_id: answers[0].question_id

        })
        set({result:response.data })
        setTimeout(() => {
          set({isLoading: false})
        }, 2000);
      }
      else {
        alert("Vui lòng hoàn thành toàn bộ trước khi nộp bài!")
        set({error: "Vui lòng hoàn thành toàn bộ trước khi nộp bài!"})
      }
    } catch (error) {

    }
  },

  redo: async () => {
    window.location.reload()
    set({ result: null, isDirty: false, answers: [], count_done: 0, error: null})

    const { fetchQuestions, test_id} = useDoTestStore.getState()
    await fetchQuestions(test_id)
  }
}))

export default useDoTestStore;
